import { axios, transformAxiosError } from "../utils/axios.create";
import {
  GoalTemplate,
  GoalTemplatePayload,
} from "../domain/goalTemplates.interface";

export type GoalTemplatesFindAllPayload = {
  sortField: string;
  sortOrder: number;
  pageNumber: number;
  pageSize: number;
  search: string;
  status: string;
  rewardConfigurationId: string;
};

const findAll = async ({
  sortField,
  sortOrder,
  pageNumber,
  pageSize,
  search,
  status,
  rewardConfigurationId,
}: GoalTemplatesFindAllPayload): Promise<{
  list: GoalTemplate[];
  totalCount: number;
}> => {
  const queryParams = new URLSearchParams({
    search,
    status,
    rewardConfigurationId,
    pageNumber: String(pageNumber + 1),
    pageSize: String(pageSize),
    sortField,
    sortOrder: sortOrder === 1 ? "asc" : "desc",
  });

  return axios
    .get(`/goal-templates/search?${queryParams.toString()}`)
    .then((res) => ({
      list: res.data.body.list as GoalTemplate[],
      totalCount: res.data.body.totalCount as number,
    }))
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const createOne = async (
  payload: GoalTemplatePayload
): Promise<GoalTemplate> => {
  return axios
    .post("/goal-templates", payload)
    .then((res) => res.data.body as GoalTemplate)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const updateOne = async ({
  id,
  payload,
}: {
  id: string;
  payload: GoalTemplatePayload;
}): Promise<GoalTemplate> => {
  return axios
    .put(`/goal-templates/${id}`, payload)
    .then((res) => res.data.body as GoalTemplate)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const archiveOne = async (id: string): Promise<void> => {
  return axios
    .delete(`/goal-templates/${id}`)
    .then(() => undefined)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

export const GoalTemplatesService = {
  findAll,
  createOne,
  updateOne,
  archiveOne,
};
